import { Type } from '@angular/core';

/**
 * ## Lazy Loader Contract
 *
 * Dynamically imports the proposal history grid module and returns the component type.
 * This keeps heavy grid code out of the initial bundle and allows consumers
 * (dialogs/widgets) to mount it only when needed.
 *
 * @returns Promise of component constructor.
 */
export const loadProposalHistoryGridComponent = (): Promise<Type<any>> =>
  import('./proposal-history-grid.module').then(m => m.ProposalHistoryGridComponent);
